import axios from 'axios';
import { CapacitorHttp } from '@capacitor/core';
import type { HttpResponse } from '@capacitor/core';
import { useIndexedDBStore } from '@/composables/useIndexDB';
import { downloadImages, parsePosts } from '@/composables/usePost';
import type { WPPost } from '@/contentTypes';
import _ from 'lodash';
import { API_CONSTANTS } from '@/configs/constants';

const instance = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    timeout: API_CONSTANTS.REQUEST_TIMEOUT_MS,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-API-Key': import.meta.env.VITE_API_KEY,
    },
});

instance.interceptors.request.use(
    (config) => {
        // Add API key to all requests
        if (!config.headers['X-API-Key']) {
            config.headers['X-API-Key'] = import.meta.env.VITE_API_KEY;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

instance.interceptors.response.use(
    async (response) => {
        // if (response.config.method === 'get' && response.config.url?.includes('/wp-json/wp/v2/posts') && response.data?.length && response.config.url?.includes('status=publish') && !response.config.url?.includes('_fields=')) {
        //     const indexDB = useIndexedDBStore('posts');
        //     const posts = parsePosts(response.data) as WPPost[];
        //     // Store the posts in IndexedDB
        //     await indexDB.set(posts).catch((error) => {
        //         console.error('Error storing posts in IndexedDB:', error);
        //     });

        //     downloadImages(posts);
        // }
        return response;
    },
    (error) => {
        return Promise.reject(error);
    },
);

export default instance;

function createUrl(path: string) {
    if(!path.startsWith('http')) {
        return import.meta.env.VITE_API_URL + path;
    }
    return path;
}

const get = async (url: string, config?: any) => {
    return new Promise<HttpResponse>((resolve, reject) => {
        CapacitorHttp.get({
            url: createUrl(url),
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-API-Key': import.meta.env.VITE_API_KEY,
            },
            ...config,
        })
            .then((res) => {
                if (config?.signal?.aborted) {
                    throw new Error('AbortError');
                }
                resolve(res);
            })
            .catch(reject);
    });
};

const post = async (url: string, data: any, config?: any) => {
    return new Promise<HttpResponse>((resolve, reject) => {
        CapacitorHttp.post({
            url: createUrl(url),
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-API-Key': import.meta.env.VITE_API_KEY,
            },
            data,
            ...config,
        })
            .then((res) => {
                if (config?.signal?.aborted) {
                    throw new Error('AbortError');
                }
                resolve(res);
            })
            .catch(reject);
    });
};

export { get, post };
